import { Model } from "@rematch/core";
import { IGooglePlace } from "shared/model/ICoworkGeoLocation";

import { StateModules } from "../types";
import { IState } from "./..";
import { updateSelectedPlace } from "./PartnersBotEffects";

export interface IPartnersBotModel extends Model {
  name: StateModules;
  state: IPartnersBotState;
  reducers: IPartnersBotReducers;
  effects: IPartnersBotEffects;
}

export type IPartnersBotState = {};

export type IPartnersBotReducers = {};

export type IPartnersBotEffects = {
  updateSelectedPlace: (
    params: { place: IGooglePlace | string | undefined },
    state: IState
  ) => void;
};

export type IPartnersBotDispatch = {
  updateSelectedPlace: (params: {
    place: IGooglePlace | string | undefined;
  }) => void;
};

export const PartnersBotModule: IPartnersBotModel = {
  name: "partners",
  state: {},
  reducers: {},
  effects: {
    updateSelectedPlace
  }
};



// WEBPACK FOOTER //
// ./src/state/modules/partnersBot/PartnersBotModule.ts